export default "__VITE_ASSET__DQkhCA85__"